/**
 * Formats the time portion of a date following the machine's locale
 * conventions (12h vs 24h), e.g. "3:42 PM" or "15:42".
 *
 * @param   {Date} date date whose time to format
 *
 * @return  {string} locale-formatted time
 */
export const formatLocalTime = (date: Date): string =>
    date.toLocaleTimeString(undefined, {
        hour: 'numeric',
        minute: '2-digit'
    });
